module.exports = __webpack_public_path__ + "static/media/black-cat.bc9846bc.png";